/* eslint-disable radix */
/* eslint-disable prefer-template */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
// material
import {
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Paper,
  TableHead,
  Grid,
  Box,
  Modal,
  TextField,
  LinearProgress,
  InputAdornment,
  IconButton,
  Divider,
  MenuItem,
  Skeleton,
  Badge,
  Menu,
  Alert,
  CircularProgress,
  alpha,
} from '@mui/material';
// eslint-disable-next-line import/no-duplicates
import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
  getCountFromServer,
  orderBy,
  startAfter,
  endBefore,
  limitToLast,
  updateDoc,
} from 'firebase/firestore';
import { PDFDownloadLink } from '@react-pdf/renderer';

// eslint-disable-next-line import/no-duplicates

import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { LoadingButton } from '@mui/lab';
import { httpsCallable } from 'firebase/functions';
import { styled } from '@mui/system';
import { db, functions } from '../../firebase.config';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
// mock

import PdfDocument from '../../components/pdf/pdfdoc';
import Swipeable from '../crm/component/swiper';
import { Variables } from '../../context/VariableContext';
import PdfTicket from '../../components/pdf/Ticket/pdfTicket';
import CustomTag from '../../components/customTag';
import CustomButton from '../../components/CustomButton';
import LucideIcon from '../../components/LucideIcon';
// eslint-disable-next-line no-var
var QRCode = require('qrcode');

// ----------------------------------------------------------------------

const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 500,
  // maxHeight:200,
  bgcolor: 'white',
  border: '1px solid white',
  borderRadius: '7px',
  boxShadow: 0,
  p: 3,
};

// ----------- for more bouton modal
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 5,
    marginTop: theme.spacing(1),
    minWidth: 200,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 15,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

// ----------------------------------------------------------------------



const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;


export default function Participants() {
  const [searchParams, setSearchParams] = useSearchParams();
const navigate = useNavigate();
  const [curent, setCurent] = React.useState();
  const { eventID } = useParams();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);

  // GESTION DE L'OUVERTURE DU FILTRE
  const { openDrawer, setOpenDrawer } = Variables();
  const { type, setType } = Variables();

  const openFilter = async (index) => {
    setType(4);
    setOpenDrawer(!openDrawer);
  };

  const [rowsPerPage, setRowsPerPage] = useState(10);



  const handleChangePage = (event, newPage) => {
    if (page < newPage) {
      next();
    } else {
      console.log('back');
      back();
    }
    console.log(newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // pagination

  const next = async () => {
    const lastVisible = billets[billets.length - 1];
    const querySnapshot1 = await getDocs(
      query(
        collection(db, `evenement/${eventID}/billets`),
        ...queryContains,
        orderBy('createDate', 'desc'),
        startAfter(lastVisible),
        limit(10)
      )
    );
    setBillet([]);
    setCommandes([]);
    setName([]);
    querySnapshot1.forEach(async (d) => {
      setBillet((billets) => [...billets, d]);
      // get commandes
      const docSnap = await getDoc(doc(db, `evenement/${eventID}/commandes`, `${d.data().refCommande}`));
      if (docSnap.exists()) {
        setCommandes((commandes) => [...commandes, docSnap.data()]);
        setName((names) => [...names, docSnap.data().nom]);
      }
    });
  };

  const back = async () => {
    const lastVisible = billets[0];
    const querySnapshot1 = await getDocs(
      query(
        collection(db, `evenement/${eventID}/billets`),
        ...queryContains,
        orderBy('createDate', 'desc'),
        endBefore(lastVisible),
        limitToLast(10)
      )
    );
    setBillet([]);
    setCommandes([]);
    setName([]);
    querySnapshot1.forEach(async (d) => {
      setBillet((billets) => [...billets, d]);
      // get commandes
      const docSnap = await getDoc(doc(db, `evenement/${eventID}/commandes`, `${d.data().refCommande}`));
      if (docSnap.exists()) {
        setCommandes((commandes) => [...commandes, docSnap.data()]);
        setName((names) => [...names, docSnap.data().nom]);
      }
    });
  };

  // take tickets from firebase

  const [billets, setBillet] = React.useState([]);
  const [commandes, setCommandes] = React.useState([]);
  const [billetsD, setBilletD] = React.useState([]);
  const [namesD, setNameD] = React.useState([]);
  const [names, setName] = React.useState([]);
  const [queryContains, setQueryContains] = React.useState([]);
  const [prenoms, setPrenom] = React.useState([]);
  const [reload, setReload] = React.useState(false);
  // ticket download
  const [info, setInfo] = React.useState();
  React.useEffect(() => {
    (async () => {
      try {
        const term = searchParams.get('q');
        console.log('params: ', term);
        const query1 = [];
        setLoading(true);
        setCommandes([]);
        setBillet([]);
        if (term) {
          //
          const tmpfilter = term.split('&');
          console.log(tmpfilter);
          tmpfilter.forEach((element) => {
            if (element.includes('fs')) {
              console.log('filter statut');
              const tmp = element.split('=');
              console.log(tmp);
              const tmp1 = tmp[1].split(',');
              console.log(tmp1);
              const filterStatut = [];
              tmp1.forEach((element) => {
                filterStatut.push(parseInt(element));
              });
              if (filterStatut.length !== 0) {
                setQueryContains((query) => [...query, where('status', 'in', filterStatut)]);
                query1.push(where('status', 'in', filterStatut));
              }
            }
            if (element.includes('fo')) {
              console.log('filter origine');
            }
            if (element.includes('fb')) {
              console.log('filter billet');
              const tmp = element.split('=');
              console.log(tmp);
              const filterBillet = tmp[1].split(',');
              console.log(filterBillet);
              if (filterBillet.length !== 0) {
                setQueryContains((query) => [...query, where('refTicket', 'in', filterBillet)]);
                query1.push(where('refTicket', 'in', filterBillet));
              }
            }
            if (element.includes('fa')) {
              const today = new Date();
              const date = new Date(today.getFullYear(), today.getMonth(), today.getDate());
              const ttmp = new Date(today.getTime() + 24 * 60 * 60 * 1000);
              const tomorrow = new Date(ttmp.getFullYear(), ttmp.getMonth(), ttmp.getDate());
              console.log('filter date ajout');
              const tmp = element.split('=');
              console.log(tmp);
              const filterHist = tmp[1];
              console.log(filterHist);
              if (filterHist === 'today') {
                console.log('add filtre ajout');
                query1.push(where('createDate', '>=', date));
                query1.push(where('createDate', '<', new Date(today.getTime() + 24 * 60 * 60 * 1000)));
                setQueryContains((query) => [...query, where('createDate', '>=', date)]);
                setQueryContains((query) => [
                  ...query,
                  where('createDate', '<', new Date(today.getTime() + 24 * 60 * 60 * 1000)),
                ]);
              } else if (filterHist === 'yesterday') {
                query1.push(where('createDate', '<=', date));
                query1.push(where('createDate', '>=', new Date(date.getTime() - 24 * 60 * 60 * 1000)));
                setQueryContains((query) => [...query, where('createDate', '<=', date)]);
                setQueryContains((query) => [
                  ...query,
                  where('createDate', '>=', new Date(date.getTime() - 24 * 60 * 60 * 1000)),
                ]);
              } else if (filterHist === 'last-7-days') {
                query1.push(where('createDate', '<=', date));
                query1.push(where('createDate', '>=', new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000)));
                setQueryContains((query) => [...query, where('createDate', '<=', date)]);
                setQueryContains((query) => [
                  ...query,
                  where('createDate', '>=', new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000)),
                ]);
              } else if (filterHist === 'last-14-days') {
                query1.push(where('createDate', '<=', date));
                query1.push(where('createDate', '>=', new Date(date.getTime() - 14 * 24 * 60 * 60 * 1000)));
                setQueryContains((query) => [...query, where('createDate', '<=', date)]);
                setQueryContains((query) => [
                  ...query,
                  where('createDate', '>=', new Date(date.getTime() - 14 * 24 * 60 * 60 * 1000)),
                ]);
              } else if (filterHist === 'last-30-days') {
                query1.push(where('createDate', '<=', date));
                query1.push(where('createDate', '>=', new Date(date.getTime() - 30 * 24 * 60 * 60 * 1000)));
                setQueryContains((query) => [...query, where('createDate', '<=', date)]);
                setQueryContains((query) => [
                  ...query,
                  where('createDate', '>=', new Date(date.getTime() - 30 * 24 * 60 * 60 * 1000)),
                ]);
              }
            }
          });
        } else {
          //
        }
        // count
        const snapshot = await getCountFromServer(query(collection(db, `evenement/${eventID}/billets`), ...query1));
        setCount(snapshot.data().count);
        // get participants
        const first = query(
          collection(db, `evenement/${eventID}/billets`),
          orderBy('createDate', 'desc'),
          ...query1,
          limit(10)
        );
        const querySnapshot1 = await getDocs(first);
        querySnapshot1.forEach(async (d) => {
          setBillet((billets) => [...billets, d]);
          // get commandes
          const docSnap = await getDoc(doc(db, `evenement/${eventID}/commandes`, `${d.data().refCommande}`));
          if (docSnap.exists()) {
            setCommandes((commandes) => [...commandes, docSnap.data()]);
            setName((names) => [...names, docSnap.data().nom]);
          }
        });
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
      setLoading(false);
    })();
  }, [reload, searchParams]);

  // loading
  const [loading, setLoading] = React.useState(false);

  // handle modification
  const [modif, setModif] = React.useState(false);

  const [curIndex, setIndex] = React.useState();

  const [statusBillet, setStatus] = React.useState('');
  const [origine, setOrigine] = React.useState();

 // modification d'un billet
 const handleModif = async (index) => {
  setLoading(true);
  navigate(`show/${billets[index].id}`)

  setLoading(false);
};

  // convert timestamp

  const handleTimestamp = (e) => {
    const date = e.toDate();
    const tmp = date.toJSON().split('.');
    return tmp[0];
  };
  const [word, setWord] = React.useState('');
  const [isRech, setRech] = React.useState(false);
  const [isFiltre, setFiltre] = React.useState(false);
  const [filtre, openFiltre] = React.useState(false);
  const handleRecherche = async (e) => {
    setWord(e);
    console.log(e);
    try {
      if (e.length > 3) {
        console.log(e);
        setLoading(true);
        setCommandes([]);
        setBillet([]);

        const regexT = /(T\d+(\.\d)*)/;
        const regexC = /(C\d+(\.\d)*)/;

        if (e.match(regexT) !== null) {
          console.log('this is a ticket');
          /* const q1 = query(
            collection(db, "evenement"),
            where("status", "==", 1),
            where(
              "dateDebut",
              ">=",
              new Date(today.getFullYear(), today.getMonth(), today.getDate())
            ),
            orderBy("dateDebut", "asc"),
          ); 
          const querySnapshot = await getDocs(q); */
          // get participants
          const snapshot = await getCountFromServer(
            query(
              collection(db, `evenement/${eventID}/billets`),
              where('numero', '>=', e),
              where('numero', '<=', e + '~'),
              limit(10)
            )
          );
          setCount(snapshot.data().count);
          const querySnapshot1 = await getDocs(
            query(
              collection(db, `evenement/${eventID}/billets`),
              where('numero', '>=', e),
              where('numero', '<=', e + '~'),
              limit(10)
            )
          );
          querySnapshot1.forEach(async (d) => {
            console.log(d.data());
            setBillet((billets) => [...billets, d]);
            // get commandes
            const docSnap = await getDoc(doc(db, `evenement/${eventID}/commandes`, `${d.data().refCommande}`));
            if (docSnap.exists()) {
              setCommandes((commandes) => [...commandes, docSnap.data()]);
            }
          });
        } else if (e.match(regexC) !== null) {
          console.log('this is a Command');
          const snapshot = await getCountFromServer(
            query(
              collection(db, `evenement/${eventID}/billets`),
              where('refCommande', '>=', e),
              where('refCommande', '<=', e + '~'),
              limit(10)
            )
          );
          setCount(snapshot.data().count);
          const querySnapshot1 = await getDocs(
            query(
              collection(db, `evenement/${eventID}/billets`),
              where('refCommande', '>=', e),
              where('refCommande', '<=', e + '~'),
              limit(10)
            )
          );
          querySnapshot1.forEach(async (d) => {
            console.log(d.data());
            setBillet((billets) => [...billets, d]);
            // get commandes
            const docSnap = await getDoc(doc(db, `evenement/${eventID}/commandes`, `${d.data().refCommande}`));
            if (docSnap.exists()) {
              setCommandes((commandes) => [...commandes, docSnap.data()]);
            }
          });
        }
        setLoading(false);
        setRech(true);
      }
      if (e.length === 0) {
        setReload(!reload);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleClear = () => {
    setWord('');
    setRech(false);
    setReload(!reload);
  };

  const handleReinitialiser = () => {
    setFiltre(false);
    handleClear();
  };

  const handleFilter = () => {
    console.log('ouvrir le filtre');
    console.log(openDrawer);
    setType(4);
    setOpenDrawer(!openDrawer);
  };

  const handleImport = () => {
    handleCloseMenu();
    console.log('');
    console.log(openDrawer);
    setType(5);
    setOpenDrawer(!openDrawer);
  };

  // filtre
  const [filters, setFilters] = useState([]);

  // more acceuil participant
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // more acceuil participant
  const [anchorElDetail, setAnchorElDetail] = React.useState(null);

  const handleCloseMenuDetail = () => {
    setAnchorElDetail(null);
  };

  // Modal download liste participants
  const [openDownloadModal, setOpenDownloadModal] = React.useState(false);
  const handleOpenDownloadModal = () => setOpenDownloadModal(true);
  const handleCloseDownloadModal = () => setOpenDownloadModal(false);

  const downloadList = async () => {
    handleCloseMenu();
    handleOpenDownloadModal();
    try {
      // get participants
      const first = query(collection(db, `evenement/${eventID}/billets`), orderBy('createDate', 'desc'));
      const querySnapshot1 = await getDocs(first);
      querySnapshot1.forEach(async (d) => {
        setBilletD((billets) => [...billets, d]);
        // get commandes
        const docSnap = await getDoc(doc(db, `evenement/${eventID}/commandes`, `${d.data().refCommande}`));
        if (docSnap.exists()) {
          setNameD((names) => [...names, docSnap.data().nom]);
        }
      });
    } catch (error) {
      console.log(error);
    }
    // handleCloseDownloadModal();
  };

  // Modal download Ticket
  const [openTicketModal, setOpenTicketModal] = React.useState(false);
  const handleOpenTicketModal = () => setOpenTicketModal(true);
  const handleCloseTicketModal = () => setOpenTicketModal(false);
  const [qrcode, setQr] = useState('');

  const downloadSelectedTicket = async (index) => {
    try {
      const docSnap = await getDoc(doc(db, `evenement`, `${eventID}`));
      if (docSnap.exists()) {
        console.log(docSnap.data());
        console.log(billets[index]);
        const orgSnap = await getDoc(doc(db, `organisations`, `${docSnap.data().orgId}`));
        console.log(orgSnap.data());
        const tmp = {
          billet: billets[index].data(),
          event: docSnap.data(),
          commande: commandes[index],
          org: orgSnap.data(),
        };
        setInfo(tmp);
      }

      QRCode.toDataURL(
        billets[index].data().numero,
        {
          width: 130,
          margin: 1,
          errorCorrectionLevel: 'H',
          color: {
            dark: '#000000',
            light: '#ffffff',
          },
        },
        (err, url) => {
          if (err) return console.log('erreur : ', err);
          setQr(url);
        }
      );
    } catch (error) {
      console.log(error);
    }
    handleCloseMenuDetail();
    handleOpenTicketModal();
    // handleCloseDownloadModal();
  };







  return (
    <Page title="Gestion Participants">
      {loading && <LinearProgress />}

      <Container sx={{ marginTop: { xs: 3 } }}>
        <Grid container spacing={2}>
          <Grid item xs={10} sm={10} md={10}>
            <Typography variant="h3" gutterBottom>
              Gérer les participants ({count}) <br />
              <Typography variant="body2">Trouver et administrer les commandes</Typography>
            </Typography>
          </Grid>
          <Grid sx={{ display: 'flex', justifyContent: 'end', alignItems: 'end', bg: 'yellow' }} item xs={2}>
            <Box>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={openMenu ? 'long-menu' : undefined}
                aria-expanded={openMenu ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClickMenu}
                sx={{ border: '1px solid gainsboro' }}
              >
                <Iconify icon="material-symbols-light:more-vert" />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
        <StyledMenu
          id="long-menu"
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleCloseMenu}
        >

          <MenuItem onClick={handleImport} disableRipple value={0}>
            <Typography variant='body1'>Importer des commandes</Typography>
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              handleCloseMenu();
              // handleOpenDeleteModal()
              downloadList()
            }}
            disableRipple
            value={1}
          >
            <Typography variant='body1'>Télécharger la liste des participants</Typography>
          </MenuItem>

        </StyledMenu>

        <Modal
          open={openDownloadModal}
          onClose={handleCloseDownloadModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ borderRadius: '7px' }}
        >
          <Box sx={styleModal}>
            <Typography variant="body2">
              Cliquez{' '}
              <PDFDownloadLink
                document={<PdfDocument billetList={billetsD} commandeList={namesD} />}
                fileName={'liste_participants.pdf'}
              >
                {({ blob, url, loading, error }) => {
                  console.log('erreur : ', error);
                  return loading ? 'Genration du ticket......' : 'ici';
                }}
              </PDFDownloadLink>{' '}
              pour Telecharger la liste des participants
            </Typography>
          </Box>
        </Modal>
        <Modal
          open={openTicketModal}
          onClose={handleCloseTicketModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ borderRadius: '7px' }}
        >
          <Box sx={styleModal}>
            <Typography variant="body2">
              Cliquez{' '}
              <PDFDownloadLink
                document={<PdfTicket info={info} qr={qrcode} />}
                fileName={`${info ? info.billet.refCommande : 'undefined'}.pdf`}
              >
                {({ blob, url, loading, error }) => {
                  console.log('erreur : ', error);
                  return loading ? 'Genration du ticket......' : 'ici';
                }}
              </PDFDownloadLink>{' '}
              pour techarger le ticket
            </Typography>
          </Box>
        </Modal>
        <Stack
          direction='row'
          justifyContent={{ xs: 'start', sm: 'end' }}
          alignItems='center'
          spacing={2}
          sx={{ width: '100%' }}
          mt={3}
          paddingBottom={2}
          useFlexGap flexWrap="wrap"
        >
          <TextField
            value={word}
            onChange={(e) => handleRecherche(e.target.value)}
            // size="small"
            placeholder="Rechercher"
            id="outlined-start-adornment"
            sx={{ m: 1, width: '40ch' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                 <LucideIcon name="Search" />
                </InputAdornment>
              ),
            }}
          />
          {queryContains.length > 0 ? (
            <Badge badgeContent=" " color="primary">
              <CustomButton startIcon={<LucideIcon name="Funnel" />} type='primaire' buttonText='Filtres' onClick={openFilter} />
            </Badge>
          ) : (
            <CustomButton startIcon={<LucideIcon name="Funnel" />} type='primaire' buttonText='Filtres' onClick={openFilter} />
          )}

         
        </Stack>

        <Box>
          {/** filtrer */}
          <Divider />
          <Scrollbar>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 500 }} aria-label="caption table">
                <TableHead>
                  <TableRow>

                    <TableCell align="left">Billet</TableCell>
                    <TableCell align="left">Acheteur</TableCell>
                    <TableCell align="left">Tags</TableCell>
                    <TableCell align="left"/>
                  </TableRow>
                </TableHead>
                {loading ? (
                  <caption>
                    <Skeleton variant="rounded" width="100%" />
                  </caption>
                ) : billets.length === 0 && !loading ? (
                  <caption>
                    <Stack spacing={1} sx={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                      <Iconify icon="icomoon-free:drawer2" sx={{ width: 30, height: 30 }} />
                      <Typography variant="caption">Aucune donnée</Typography>
                    </Stack>
                  </caption>
                ) : (
                  <>
                    {
                      <TableBody>
                        {commandes.length === billets.length &&
                          billets.map((billet, index) => (
                            <TableRow key={index} sx={{ cursor: 'pointer' }} hover>

                              <TableCell align="left" onClick={() => handleModif(index)}>
                                <Stack>
                                  <Typography variant='subtitle2'>{billet.data().numero}</Typography>
                                  <Typography variant="caption">N° Commande : <strong>{billet.data().refCommande}</strong></Typography>
                                  <Typography variant='caption'> Acheté le {format(new Date(handleTimestamp(commandes[index].date)), 'EEEE dd, MMMM yyyy', { locale: fr })} à {format(new Date(handleTimestamp(commandes[index].date)), 'HH:mm', { locale: fr })}</Typography>
                                </Stack>
                              </TableCell>
                              <TableCell align="left" onClick={() => handleModif(index)}>
                                <Stack>
                                  <Typography variant='subtitle2'>

                                    {commandes[index].nom === '' ? (
                                      <div>Inconnu</div>
                                    ) : (
                                      <div>{commandes[index].nom}</div>
                                    )}


                                  </Typography>
                                  <Stack direction="row" spacing={1} alignItems="center">
                                    <Iconify icon="ion:mail-outline" />
                                    <Typography variant="caption">{commandes[index].email}</Typography>
                                  </Stack>
                                </Stack>
                              </TableCell>

                              <TableCell align="center" onClick={() => handleModif(index)}>
                                <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                  {billet.data().scanner === 1 && (
                                    <CustomTag text={'scanné'} />
                                  )}
                                  {billet.data().status === 2 && (
                                    <CustomTag text={'validé'} type={'success'}/>
                                  )}
                                  {commandes[index].status === 1 && (
                                    <CustomTag text={'payé'} />

                                  )}
                                  {commandes[index].status === 0 && (
                                   <CustomTag text={'reservé'} />
                                  )}
                                </Stack>
                              </TableCell>
                              <TableCell align="right">
                                <IconButton key={index} onClick={(e) => downloadSelectedTicket(index)}>
                                <LucideIcon name="Download" size={20}/>
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    }
                  </>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Scrollbar>
        </Box>
      </Container>
      {
        type === 4 && <Swipeable type={type} eventID={eventID} />
      }
    </Page>
  );
}
